import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
    settheInternalDepartmentsctions,
    setTheSubQueryIDs,
    setTheInternalDepartmentDeleteActions, ///delete
} from "../../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import DeleteImages from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import DepartmentCrud from "./DepartmentCrud";
import ViewSymblos from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-23.svg";


const Departmentlist = () => {
    const dispatch = useDispatch();
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );

    const navigator = useNavigate();
    const state = useSelector((state) => state);
    const [RoleCreatePopup, setRoleCreatePopup] = useState(false);
    const [newpages, setNewpage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [search, setsearch] = useState("");
    const [pageSize, setPageSize] = useState(20);
    const [DeletePOPUP, setDeletePOPUP] = useState(false);
    const [DeleteID, setDeleteID] = useState("");
    const [EditId, setEditID] = useState();

    const [ParentId, setParentid] = useState(state.NeededdatasListed.SubQueryIDs);
    const [ActiveContent, setActiveContent] = useState({
        is_active: true,
        id: "",
    })
    const [activepopup, setactivePopup] = useState(false)



    useEffect(() => {
        const payload = {
            search: search,
            page_size: 20,
            page: dtpageindex,
        };
        dispatch(settheInternalDepartmentsctions(payload));
    }, [dtpageindex, search]);
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e)
            }, 500),
        []
    );

    function tochange(e) {
        setsearch(e);
        debouncedSearch(e);

    }

    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    const pagesize = (arg) => {
        setdtPagesize(arg);
    };
    const pageindex = (arg) => {
        //  console.log(arg, "args");
        setdtPageindex(arg);
    };


    const formatedDateListwithouttime = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}`;
    };
    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };

    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage)
    }

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);

        }
    };


    const ViewFunctions = (e) => {
        dispatch(setTheSubQueryIDs(e.id));
        if (e.id == state.NeededdatasListed.SubQueryIDs) {
            navigator("/internalinnerdepartment");
        }
    };
    const columns = [
        {
            Header: "Department Name",
            accessor: "",
            Cell: (row) => {
                return (
                    <>
                        {row.row.original.department_name ? (
                            <span>{truncateText(row.row.original.department_name, 30)}</span>
                        ) : (
                            <span>---</span>
                        )}
                    </>
                );
            },
        },

        {
            Header: "Created Date",
            accessor: "",
            Cell: (row) => {
                const dateString = row.row.original.created_at;
                const dateObject = new Date(dateString);
                const hours = dateObject.getHours();
                const minutes = dateObject.getMinutes();
                const seconds = dateObject.getSeconds();
                const amOrPm = hours >= 12 ? "PM" : "AM";
                const twelveHourFormat = hours % 12 || 12;
                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                return (
                    <>
                        <span>
                            {row.row.original.created_at ? formatedDateListwithouttime(row.row.original.created_at)
                                : ""
                            }
                            {/* {`${row.row.original.created_at.sli////ce(0, 10)}`} */}
                        </span>
                    </>
                );
            },
        },
        {
            Header: "Description",
            accessor: "",
            Cell: (row) => {
                return (
                    <>
                        {row.row.original.description ? (
                            <span>{truncateText(row.row.original.description, 30)}</span>
                        ) : (
                            <span>---</span>
                        )}
                    </>
                );
            },
        },


        {
            Header: "Actions",
            accessor: "",
            Cell: (row) => {
                return (
                    <>
                        {row.row.original != undefined &&
                            row.row.original.id != undefined &&
                            row.row.original.id != undefined &&
                            row.row.original.id != undefined ? (
                            <div
                                class="actions"
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    gap: "5px",
                                }}
                            >
                                <button
                                    className=" btn Status"
                                    onClick={(e) => {
                                         e.stopPropagation()
                                        setEditID(row.row.original.id);
                                        setRoleCreatePopup(true);
                                    }}
                                    component="span"
                                >
                                    <span className="OuterActionSpan">

                                        <span className="EditImages">
                                            <img src={EditImages} />
                                        </span>
                                        <span className="ActionsList"> Edit </span>
                                    </span>
                                </button>

                                <button
                                    type="button"
                                    class="btn Status"
                                    onClick={(e) => {
                                        e.stopPropagation()

                                        setDeleteID(row.row.original.id);
                                        setDeletePOPUP(true);
                                    }}
                                >
                                    <span className="OuterActionSpan">

                                        <span className="EditImages">
                                            <img src={DeleteImages} />
                                        </span>

                                        <span className="ActionsList"> Delete </span>
                                    </span>
                                </button>


                                <button
                                type="button"
                                class="btn Status"
                                onClick={(e) => {
                                    e.stopPropagation();

                                    dispatch(setTheSubQueryIDs(row.row.original.id));
                                    if (
                                        row.row.original.id == state.NeededdatasListed.SubQueryIDs
                                    ) {
                                        navigator("/internalinnerdepartment");
                                    }
                                }}
                            >
                                <span className="OuterActionSpan">
                                    <span className="EditImages">
                                        <img src={ViewSymblos} />
                                    </span>

                                    <span className="ActionsList"> View </span>
                                </span>
                            </button>


                            </div>
                        ) : null}
                    </>
                );
            },
        },
    ];

    const HandleDeletes = () => {
        if (DeleteID != undefined) {
            const payload = {
                DeleteId: DeleteID,
                currentPage: dtpageindex,
            };
            dispatch(setTheInternalDepartmentDeleteActions(payload, setDeletePOPUP(false)));
        }
    };

    // console.log(state.InternalSubDepartmentsDatas.internalDepartmentDatas, "internalDepartmentDatas internalDepartmentDatas");

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "14px 28px" }}
                >
                    <div
                        class="col-sm-7 auto"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <h3>Department</h3>

                    </div>
                    <div className="createticketing col-sm-5">
                        <button
                            style={{ zIndex: "555" }}
                            onClick={(e) => {
                                setRoleCreatePopup(true);
                                setEditID("");
                            }}
                            className="Createbutton"
                        >
                            Create
                        </button>
                    </div>
                </div>



                <div style={{ padding: " 20px 40px", }}>
                    <ReactTable
                        data={state?.InternalSubDepartmentsDatas?.internalDepartmentDatas ? state.InternalSubDepartmentsDatas.internalDepartmentDatas : []}
                        columns={columns}
                        totalItems={state.InternalSubDepartmentsDatas.Total_Count}
                        currentPage={currentPage}
                        onChange={tochange}
                        setCurrentPage={setCurrentPage}
                        pagesize={pagesize}
                        dtpagesize={pageSize}
                        dtpageindex={dtpageindex}
                        pageindex={pageindex}
                        onPrevious={handlePrevious}
                        onNextpage={handleNext}
                        GotoEnteredPage={GotoEnteredPage}
                        datacount={state.InternalSubDepartmentsDatas.Total_Count}
                        MakeCreate={true}
                        ViewParts={(e) => {
                            ViewFunctions(e);
                        }}
                        Filter={true}
                        NoFilter={true}

                    />
                </div>
            </div>
            {RoleCreatePopup == true ? (
                <DepartmentCrud
                    show={RoleCreatePopup}
                    setShow={setRoleCreatePopup}
                    currentPage={dtpageindex}
                    EditId={EditId}
                    getsearch={search}
                />
            ) : null}

{DeletePOPUP ? (
                <Delete
                    show={DeletePOPUP}
                    setShow={setDeletePOPUP}
                    onSubmit={HandleDeletes}
                    Content={"Do you want to delete the Department"}

                />
            ) : null}
        </>

    )
}

export default Departmentlist